import { SettingsController } from 'api/controllers/SettingsController';
import { EditableSettings } from 'api/controllers/typings';
import { GET_SETTINGS } from '../queryKeys';
import { useTemplateMutation } from '../templates';

export const useSetSettings = useTemplateMutation<EditableSettings, void>({
  mutationFn: data => SettingsController.setSettings(data),
  refetchQueries: [GET_SETTINGS],
});
